// app/javascript/controllers/sales_chart.js
document.addEventListener("turbo:load", () => {
  const chartEl = document.querySelector("#sales-chart");
  if (chartEl && window.ApexCharts) {
    const params = new URLSearchParams(window.location.search);

    fetch(`/reports/sales.json?${params.toString()}`)
      .then(response => response.json())
      .then(data => {
        const categories = data.map(item =>
          new Date(item.date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
        );
        const seriesData = data.map(item => item.total);

        const options = {
          series: [{ name: "Sales", data: seriesData }],
          chart: { height: 300, type: "line", toolbar: { show: false } },
          colors: ["#0d6efd"], // Bootstrap primary blue
          dataLabels: { enabled: false },
          stroke: { curve: "smooth" },
          xaxis: { categories: categories },
          tooltip: { x: { format: "dd MMM yyyy" } }
        };

        new ApexCharts(chartEl, options).render();
      })
      .catch(error => console.error("Error loading sales chart data:", error));
  }
});
